import { BALANCE, type MixKind } from '../config/balance';
import type { EnemyKind, RunMode } from '../core/types';

export type NumberCurve = readonly (readonly [number, number])[];
type VectorCurve = readonly (readonly [number, readonly number[]])[];

export function sampleCurve(curve: NumberCurve, t: number): number {
  if (t <= curve[0][0]) return curve[0][1];
  for (let i = 1; i < curve.length; i++) {
    const [t1, v1] = curve[i];
    if (t <= t1) {
      const [t0, v0] = curve[i - 1];
      const k = (t - t0) / (t1 - t0);
      return v0 + (v1 - v0) * k;
    }
  }
  return curve[curve.length - 1][1];
}

function sampleMix(curve: VectorCurve, t: number): readonly number[] {
  if (t <= curve[0][0]) return curve[0][1];
  for (let i = 1; i < curve.length; i++) {
    const [t1, v1] = curve[i];
    if (t <= t1) {
      const [t0, v0] = curve[i - 1];
      const k = (t - t0) / (t1 - t0);
      return v1.map((v, j) => v0[j] + (v - v0[j]) * k);
    }
  }
  return curve[curve.length - 1][1];
}

export const MIX_KINDS: readonly MixKind[] = [
  'chaser', 'charger', 'spitter', 'bomber', 'elite',
];

export interface WaveTable {
  duration: number;
  intervalCurve: NumberCurve;
  mix: VectorCurve;
  bursts: readonly {
    t: number;
    v: readonly number[];
    boss?: EnemyKind;
  }[];
}

/** 模式 → 波次表：日课 / 练习用 6 分钟表（练习无限），日赛用 14 分钟表。 */
export function tableForMode(mode: RunMode): WaveTable {
  const w = BALANCE.waves;
  if (mode === 'race') {
    const r = w.race;
    return {
      duration: r.duration,
      intervalCurve: r.intervalCurve,
      mix: r.mix,
      bursts: r.bursts,
    };
  }
  const l = w.lesson;
  return {
    duration: l.duration,
    intervalCurve: l.intervalCurve,
    mix: l.mix,
    bursts: l.bursts,
  };
}

/** 当前怪种混合权重（连续刷怪用）。 */
export function mixWeights(table: WaveTable, t: number): number[] {
  return [...sampleMix(table.mix, t)];
}
